import { render, staticRenderFns } from "./LoveMsgParamItem.vue?vue&type=template&id=465bc1d3&scoped=true&"
import script from "./LoveMsgParamItem.vue?vue&type=script&lang=js&"
export * from "./LoveMsgParamItem.vue?vue&type=script&lang=js&"
import style0 from "./LoveMsgParamItem.vue?vue&type=style&index=0&id=465bc1d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465bc1d3",
  null
  
)

export default component.exports